import { computed, ComputedRef } from 'vue'
import getIsTravellersFilled from '@/logic/getIsTravellersFilled'
import assuranceAnnulationDecision from '@/state/assuranceAnnulationDecision'
import OptionsPageFieldEnum from '@/enum/OptionsPageFieldEnum'
import isAcceptConditions from '@/state/isAcceptConditions'

const optionsPageInvalidFields: ComputedRef<Set<OptionsPageFieldEnum>> =
    computed(() => {
        const invalid_fields: Set<OptionsPageFieldEnum> =
            new Set<OptionsPageFieldEnum>()
        const isTravellersFilled = true // DISABLED
        // const isTravellersFilled = getIsTravellersFilled()
        if (!isAcceptConditions.value)
            invalid_fields.add(OptionsPageFieldEnum.ACCEPT_CONDITIONS)
        if (!isTravellersFilled)
            invalid_fields.add(OptionsPageFieldEnum.PARTICIPANTS_BOX)

        // REMOVED FOR THE INSURACE POPUP, DO NOT DELETE
        // if (!assuranceAnnulationDecision.value)
        //     invalid_fields.add(OptionsPageFieldEnum.ASSURANCE_ANNULATION)
        return invalid_fields
    })

export default optionsPageInvalidFields
